var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { H3 } from "@irati/ui/src/Headings";
import { injectIntl } from "@irati/utils/lang";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import Button from "@irati/ui/src/Button";
import Modal from "@irati/ui/src/Modal";
import { ModalHeader } from "@irati-web/recognition/src/components/Popup/shared/Modal";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
var StyledH3 = styled(H3)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var SendCreditsuccessModal = /** @class */ (function (_super) {
    __extends(SendCreditsuccessModal, _super);
    function SendCreditsuccessModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendCreditsuccessModal.prototype.render = function () {
        var _a = this.props, recipient = _a.recipient, value = _a.value, formatMessage = _a.formatMessage, onClose = _a.onClose;
        return (React.createElement(Modal, { show: true, onHide: onClose, onExited: onClose, renderHeader: function (_a) {
                var size = _a.size;
                return React.createElement(ModalHeader, { users: [recipient], size: size });
            } },
            React.createElement(StyledH3, { small: true }, formatMessage({ id: "wallet.sendCredit.successModal.text" }, { value: formatCurrency({ value: value }), recipient: firstnameLastname(recipient) })),
            React.createElement(Button, { large: true, full: true, primary: true, onClick: onClose }, formatMessage({ id: "wallet.sendCredit.successModal.button" }))));
    };
    return SendCreditsuccessModal;
}(PureComponent));
export default injectIntl(SendCreditsuccessModal);
var templateObject_1;
